// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.back-button {
  margin: 10px;
  width: 25px;
  height: 25px;
}

ion-icon {
  margin: 10px;
}

.name {
  margin-top: 10vh;
  margin-bottom: 1vh;
  font-weight: bold;
  font-size: 2em;
  line-height: 1em;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/personal-page/personal-qrcode/personal-qrcode.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACC,YAAA;AAAD;;AAEA;EACC,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACD","sourcesContent":[".back-button{\n    margin: 10px;\n    width: 25px;\n    height: 25px;\n\n}\n\nion-icon{\n\tmargin: 10px;\n}\n.name {\n\tmargin-top: 10vh;\n\tmargin-bottom: 1vh;\n\tfont-weight: bold;\n\tfont-size: 2em;\n\tline-height: 1em;\n\ttext-align: center;\n}\n\n// .qr-code-container {\n// \tposition: relative;\n// \twidth: 20rem;\n// \theight: 20rem;\n// \tbackground: var(--bg-color);\n// \tborder-radius: 50%;\n// \tdisplay: flex;\n// \talign-items: center;\n// \tjustify-content: center;\n// \tmargin: auto;\n// \t> ion-icon {\n// \t\tstroke: var(--text-color-2nd-login-desktop) !important;\n// \t\twidth: 10rem;\n// \t\theight: 10rem;\n// \t}\n// \t#qr-code {\n// \t\tposition: absolute;\n//        \tleft: 50%;\n//         transform: translateX(-50%);\n// \t}\n\n//     .qrcode {\n//         margin: 0 auto;\n//         display: block;\n//     }\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
